const fastAndSlowPointersProblems = [
  {
      title: "Linked List Cycle",
      url: "https://leetcode.com/problems/linked-list-cycle/"
    },
    {
      title: "Middle of the Linked List",
      url: "https://leetcode.com/problems/middle-of-the-linked-list/"
    },
    {
      title: "Linked List Cycle II",
      url: "https://leetcode.com/problems/linked-list-cycle-ii/"
    },
    {
      title: "Happy Number",
      url: "https://leetcode.com/problems/happy-number/"
    },
    {
      title: "Palindrome Linked List",
      url: "https://leetcode.com/problems/palindrome-linked-list/"
    }
];
export default fastAndSlowPointersProblems;
